import importCalendarEventService from 'owa-calendar-services/lib/services/importCalendarEventService';
import ImportCalendarEventResponseMessage from 'owa-service/lib/contract/ImportCalendarEventResponseMessage';

export default async function addToCalendarAttachmentService(
    attachmentId: string,
    content: string | null,
    importedItemFolderId: string | null
): Promise<ImportCalendarEventResponseMessage> {
    try {
        return await importCalendarEventService(content, importedItemFolderId, attachmentId);
    } catch (error) {
        return null;
    }
}
